module.exports = __webpack_public_path__ + "img/manual-receive-02-select-date.522466ef.png";